export class IFramePaymentResponse {
    emailAddress?: string;
    cartStatus?: string;
    errorMessage?: string;
    processorTrackingId?: string;

    constructor(data?: IFramePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}
